import { TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from '@mui/lab'
import { css, styled } from '@mui/material'

export const Content = styled(TimelineContent)`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(0, 0, 4, 1)};
`
export const Separator = styled(TimelineSeparator)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  padding-top: ${({ theme }) => theme.spacing(0.5)};
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};

  & span {
    border-radius: ${({ theme }) => theme.spacing(1)};
  }
`
export const Connector = styled(TimelineConnector)`
  background-color: ${({ theme }) => theme.palette.common.divider};
`

export const Item = styled(TimelineItem)`
  width: 100%;
  min-height: 0;
`

export const TimelineItemContainer = styled('div')`
  width: 100%;
  height: 100%;
  min-height: ${({ theme }) => theme.spacing(2.5)};
  padding: 0;
  ${({ theme }) => css`
    border: ${theme.spacing(0.125)} solid ${theme.palette.common.divider};
  `};
  border-radius: ${({ theme }) => theme.spacing(3)};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
`
